<template>
  <b-nav-item-dropdown
    class="dropdown-submenu"
    v-bind:class="visibilityClass"
    @toggle="toggle"
  >
    <template slot="button-content">
      <slot name="button-content"></slot>
    </template>
    <slot></slot>
  </b-nav-item-dropdown>
</template>


<script>
export default {
  name: "dropdown-submenu",
  extends: "b-nav-item-dropdown",
  data () {
    return {
      visible: false,
    }
  },
  computed: {
    visibilityClass () {
      return {
        "submenu-visible": this.visible,
        "submenu-hidden": !this.visible,
      }
    },
  },
  watch: {
    visible (newValue) {
      const evtName = newValue ? "shown" : "hidden";
      this.$root.$emit("bv::dropdown-submenu::" + evtName, this);
      this.whileOpenListen(newValue);
    },
  },
  beforeDestroy() {
    this.visible = false;
    this.whileOpenListen(false);
  },
  methods: {
    toggle (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.visible = !this.visible;
    },
    whileOpenListen (open) {
      if (open) {
        this.$root.$on("bv::dropdown-submenu::shown", this.rootCloseListener);
        this.listenClick();
      } else {
        this.$root.$off("bv::dropdown-submenu::shown", this.rootCloseListener);
        this.forgetClick();
      }
    },
    rootCloseListener (vm) {
      if (vm !== this && vm.$parent === this.$parent) {
        this.visible = false;
      }
    },
    listenClick () {
      document.addEventListener("click", this.clickHandler);
    },
    forgetClick () {
      document.removeEventListener("click", this.clickHandler);
    },
    clickHandler (evt) {
      if (!this.$el.contains(evt.target)) {
        this.visible = false;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.dropdown-submenu {
  padding: 0 1.5rem;
}

.submenu-visible ::v-deep ul {
  display: block !important;
}

.submenu-hidden ::v-deep ul {
  display: none !important;
}
</style>
